import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {useControllerProps} from '../../../../domain/controllers/ControllerContext';
import {classes} from './CouponTag.st.css';
import {SkeletonLineWrapper} from '../../Skeleton/SkeletonLine/SkeletonLineWrapper';
import {DiscountSource} from '../../../../domain/models/CartSummary/Discount.model';

export enum CouponTagDataHook {
  CouponTagText = 'CouponTag.Text',
  CouponTagSkeleton = 'CouponTag.Skeleton',
}

export const CouponTag = () => {
  const {t} = useTranslation();
  const {cartModel, isSummaryUpdating, isSummaryLoading, cartSummary} = useControllerProps().cartStore;
  const appliedCoupon = cartModel.coupon;
  const isCouponApplied = !!appliedCoupon;
  const shouldShowTag = isCouponApplied && cartModel.hasLineItemWithCouponDiscount;

  if (!shouldShowTag) {
    return null;
  }

  const getTagText = () => {
    const couponDiscount = cartSummary?.lineItemDiscounts.find(
      (discount) => discount.sourceType === DiscountSource.COUPON
    );
    const targetLineItemIds = couponDiscount?.targetLineItemIds ?? [];

    return targetLineItemIds.length === 1
      ? t('cart.promoField.savedOnItem', {
          amountOff: couponDiscount?.totalAmountOff,
          itemName: cartModel.lineItems.find((lineItem) => lineItem.id === targetLineItemIds[0])?.name,
        })
      : t('cart.promoField.savedOnItems', {
          amountOff: couponDiscount?.totalAmountOff,
          totalItems: targetLineItemIds.length,
        });
  };

  return isSummaryUpdating || isSummaryLoading ? (
    <SkeletonLineWrapper dataHook={CouponTagDataHook.CouponTagSkeleton} size="large" />
  ) : (
    <Text data-hook={CouponTagDataHook.CouponTagText} className={classes.text}>
      {getTagText()}
    </Text>
  );
};
